import { Component } from "@angular/core";
import {
  IonicPage,
  ToastController,
  Popover,
  ActionSheetController,
  ActionSheet,
  LoadingController,
  PopoverController,
  NavController,
} from "ionic-angular";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { APIOnLine } from "../../services/api/api.services";
import { PaginaBasica } from "../../models/PaginaBase";
import { Proxy } from "../../services/proxy/proxy.service";
import { NuevoMenuDerechoComponent } from "../../components/nuevo-menu-derecho/nuevo-menu-derecho";
import { iConfiguracion } from "../../models/basePage";
import { HomePage } from "../home/home";
import { NgForm } from "@angular/forms/src/directives/ng_form";
import { LesionadosService } from "../../services/api/lesionados.service";

import * as modLes from '../../models/lesionados';

@IonicPage()
@Component({
  selector: "page-finalizar",
  templateUrl: "finalizar.html",
})
export class FinalizarPage extends PaginaBasica {
  // #region Propiedades del controlador
  public designacion: Proxy.PrDesignaciones;
  public designacionCorrecta: boolean = true;
  public golesCorrectos: boolean = true;
  public golesLocales: number;
  public golesVisitante: number;
  public lesionadosCorrectos: boolean = true;
  public licenciasLocal: Proxy.ListaPrPersonaAlineable;
  public licenciasVisitante: Proxy.ListaPrPersonaAlineable;
  public participacionCorrecta: boolean = true;
  public errores: string = "";
  public firma: string = "";
  public firmaArbitroOnline: boolean = false;
  public participantesLocal: Proxy.ListaPrParticipacion;
  public participantesVisitante: Proxy.ListaPrParticipacion;
  // #endregion

  constructor(
    public ActionSheetController: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public NavCtrl: NavController,
    public Persistentes: APIOnLine.Persistentes,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController,
    public lesionadosService: LesionadosService
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log("--- ENTRO EN LA PÁGINA: FINALIZAR ---");

    this.designacion = this.Persistentes.GetDesignacion();
    this.golesLocales = this.Persistentes.GetGolesLocal();
    this.golesVisitante = this.Persistentes.GetGolesVisitante();

    this.licenciasLocal = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.designacion.idLocal);
    this.licenciasVisitante = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.designacion.idVisitante);
    this.participantesLocal = new Proxy.ListaPrParticipacion(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.toastCtrl,
      this.designacion,
      this.designacion.idLocal
    );
    this.participantesVisitante = new Proxy.ListaPrParticipacion(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.toastCtrl,
      this.designacion,
      this.designacion.idVisitante
    );

    console.log(this.designacion);

    this.Persistentes.GetConfiguracion().then((resultado: iConfiguracion) => {
      this.firmaArbitroOnline =
        resultado.internas.firmaOperacionesArbitro != null &&
          resultado.internas.firmaOperacionesArbitro == true
          ? true
          : false;

      if (
        resultado != null &&
        resultado.internas != null &&
        (resultado.internas.comprobarCondicionesFinalizacion ||
          resultado.internas.comprobarParticipacion)
      ) {
        // Comprobación de condiciones que debe cumplir la designación para que pueda finalizarse
        this.participantesLocal
          .CargarListaParticipacion()
          .then(() => {
            return this.participantesVisitante.CargarListaParticipacion();
          })
          .then(() => {

            // Carga de la información de los lesionados
            if (resultado.lesionados) {
              this.lesionadosService.obtenerPorDesignacion(this.designacion.urlApi, this.designacion.idDesignacion, this.designacion.idCalendario)
                .subscribe({
                  next: (datosLesionados: modLes.IActasLesiones_DTO) => {
                    this.ComprobarCondiciones(resultado);
                  }
                })
            } else {
              this.ComprobarCondiciones(resultado);
            }
          });
      }
    });
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event,
    });
  }

  /**
   * Comprueba si se dan las condiciones para finalizar la designación
   */
  private ComprobarCondiciones(configuraciones: iConfiguracion): void {
    let estadoEvaluable: boolean =
      this.designacion.OtrosDatos.idEstadoProvisional == 2 ||
        this.designacion.OtrosDatos.idEstadoProvisional == 4
        ? true
        : false;
    this.errores = "";
    this.participacionCorrecta = true;
    this.golesCorrectos = true;
    this.designacionCorrecta = true;
    this.lesionadosCorrectos = true;

    // Comprobación de las condiciones de finalización, siempre y cuando el estado del partido sea 'Disputado' o 'Suspendido iniciado'
    if (configuraciones.internas.comprobarParticipacion && estadoEvaluable) {
      // 1.- Se ha marcado la opción de 'doble función de delegado' o la opción 'delegados distintos'
      if (
        this.participantesLocal.TieneParticipantes() &&
        !this.designacion.OtrosDatos.dobleFuncionDelegado &&
        !this.designacion.OtrosDatos.delegadosDistintos
      ) {
        this.designacionCorrecta = false;
        this.errores +=
          "<p>La alineación de los delegados del equipo local no está correctamente establecida.</p><p>Ni se ha marcado la opción de 'delegados distintos' ni la opción de 'doble función de delegado'.</p><p>Por favor, vuelva a la pantalla de alineaciones y vuelva a establecer esos valores.</p>";
      }

      // 2.- Se ha marcado la opción de doble función de delegado, pero alguno de los identificadores no está indicado
      if (
        this.participantesLocal.TieneParticipantes() &&
        this.designacion.OtrosDatos.dobleFuncionDelegado &&
        (!this.participantesLocal.TieneDelegado(true) ||
          !this.participantesLocal.TieneDelegado(false))
      ) {
        this.designacionCorrecta = false;
        this.errores +=
          "<p>La alineación de los delegados del equipo local no está correctamente establecida.</p><p>Se ha marcado la opción de 'doble función de delegado', pero no se ha establecido correctamente al auxiliar.</p><p>Por favor, vuelva a la pantalla de alineaciones y vuelva a establecer esos valores.</p>";
      }

      // 3.- Se ha marcado la opción de delegados distintos, pero uno de los dos delegados no se indicado
      if (
        this.participantesLocal.TieneParticipantes() &&
        this.designacion.OtrosDatos.delegadosDistintos
      ) {
        let error: boolean = false;
        let esDelegadoEquipo: boolean = false;

        if (
          !this.participantesLocal.TieneDelegado(false) &&
          !this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal
        ) {
          error = true;
          esDelegadoEquipo = true;
        } else if (
          !this.participantesLocal.TieneDelegado(true) &&
          !this.designacion.OtrosDatos.noExisteDelegadoCampo
        ) {
          error = true;
        }

        if (error) {
          this.designacionCorrecta = false;
          this.errores +=
            "<p>La alineación de los delegados del equipo local no está correctamente establecida.</p><p>Se ha marcado la opción de 'delegados distintos', pero no se ha establecido correctamente al " +
            (esDelegadoEquipo
              ? " delegado de equipo "
              : " delegado de campo ") +
            ".</p><p>Por favor, vuelva a la pantalla de alineaciones y vuelva a establecer esos valores.</p>";
        }
      }

      // 4.- Se comprueba si se ha establecido la opción del delegado visitante
      if (
        this.participantesVisitante.TieneParticipantes() &&
        !this.participantesVisitante.TieneDelegado(false) &&
        !this.designacion.OtrosDatos.noExisteDelegadoEquipoVisitante
      ) {
        this.designacionCorrecta = false;
        this.errores +=
          "<p>La alineación del delegado del equipo visitante no está correctamente establecida.</p><p>No se ha indicado el delegado visitante ni se ha marcado la opción de no presenta delegado.</p><p>Por favor, vuelva a la pantalla de alineaciones y vuelva a establecer esos valores.</p>";
      }
    }

    // Comprobación de los goles correctos, siempre y cuando el estado del partido sea 'Disputado' o 'Suspendido iniciado'
    if (configuraciones.internas.comprobarGoles && estadoEvaluable) {
      if (
        this.designacion.OtrosDatos.golLocalParcial != null &&
        this.designacion.OtrosDatos.golLocalParcial > 0 &&
        this.designacion.OtrosDatos.golLocalParcial > this.golesLocales
      ) {
        this.golesCorrectos = false;
        this.errores +=
          "<p>El número de goles del equipo local en la primera parte es mayor que el número de goles totales del equipo local. Compruebe los goles establecidos o los goles indicados en la primera parte.</p>";
      }
      if (
        this.designacion.OtrosDatos.golVisitanteParcial != null &&
        this.designacion.OtrosDatos.golVisitanteParcial > 0 &&
        this.designacion.OtrosDatos.golVisitanteParcial > this.golesVisitante
      ) {
        this.golesCorrectos = false;
        this.errores +=
          "<p>El número de goles del equipo visitante en la primera parte es mayor que el número de goles totales del equipo visitante. Compruebe los goles establecidos o los goles indicados en la primera parte.</p>";
      }
    }

    // Comprobación de la participación, siempre y cuando el estado del partido sea 'Disputado' o 'Suspendido iniciado'
    if (
      configuraciones.internas.comprobarParticipacion &&
      this.designacion.Configuracion.obligadaParticipacion &&
      !this.designacion.OtrosDatos.confirmacionParticipantes &&
      estadoEvaluable
    ) {
      if (
        (this.participantesLocal.TieneParticipantes() &&
          !this.participantesLocal.TodosParticipan()) ||
        (this.participantesVisitante.TieneParticipantes() &&
          !this.participantesVisitante.TodosParticipan())
      ) {
        this.participacionCorrecta = false;
      }
    }

    // Comprobación de la presentación de entrenadores
    if (
      this.participantesLocal.TieneParticipantes() &&
      this.designacion.OtrosDatos.presentaEntrenadorLocal == null &&
      estadoEvaluable
    ) {
      this.designacionCorrecta = false;
      this.errores +=
        "<p>No se ha indicado si el equipo <b>local</b> presenta o no entrenador. En el caso de que no se presente entrenador, es necesario que se especifique en la opción correspondiente.</p>";
    }
    if (
      this.participantesLocal.TieneParticipantes() &&
      this.designacion.OtrosDatos.presentaEntrenadorLocal == true &&
      !this.participantesLocal.TieneEntrenador() &&
      estadoEvaluable
    ) {
      this.designacionCorrecta = false;
      this.errores +=
        "<p>Se ha indicado que el equipo <b>local</b> presenta entrenador, pero no se ha marcado a nadie como entrenador. Es necesario que se indique a una persona con esa función.</p>";
    }
    if (
      this.participantesVisitante.TieneParticipantes() &&
      this.designacion.OtrosDatos.presentaEntrenadorVisitante == null &&
      estadoEvaluable
    ) {
      this.designacionCorrecta = false;
      this.errores +=
        "<p>No se ha indicado si el equipo <b>visitante</b> presenta o no entrenador. En el caso de que no se presente entrenador, es necesario que se especifique en la opción correspondiente.</p>";
    }
    if (
      this.participantesVisitante.TieneParticipantes() &&
      this.designacion.OtrosDatos.presentaEntrenadorVisitante == true &&
      !this.participantesVisitante.TieneEntrenador() &&
      estadoEvaluable
    ) {
      this.designacionCorrecta = false;
      this.errores +=
        "<p>Se ha indicado que el equipo <b>visitante</b> presenta entrenador, pero no se ha marcado a nadie como entrenador. Es necesario que se indique a una persona con esa función.</p>";
    }

    // Comprobación de los lesionados
    if (configuraciones.lesionados && estadoEvaluable && !this.lesionadosService.informacionLesionadosValida(this.designacion.idLocal, this.designacion.idVisitante)) {
      this.designacionCorrecta = false;
      this.errores +=
        "<p>La información de los <strong>lesionados</strong> no es correcta. Por favor, revise que ha indicado correctamente los valores y que ha guardado la información.</p>";
    }
  }

  /**
   * Marca la participación de los jugadores que no han participado en el partido.
   * Se guarda la información en el campo 'incidenciasNoModificables' de la designación.
   */
  public MarcarParticipacion(): void {
    let plantilla: string = "<p>El jugador {0} del equipo {1} no ha participado en el partido.</p>";

    this.designacion.OtrosDatos.confirmacionParticipantes = true;
    this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
    this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

    // Generar un texto con la información de los jugadores que no participan, para guardarlo dentro del campo 'incidenciasNoModificables'.
    let texto: string = "<h4>No participación</h4><p>Los siguientes jugadores no han participado en el partido:</p>";
    if (this.participantesLocal.TieneParticipantes()) {
      this.participantesLocal.lista.forEach((participante) => {
        if (!participante.participa) {
          let nombreJugador: string = this.licenciasLocal.NombreCompletoPorParticipante(participante);

          texto += plantilla.replace("{0}", nombreJugador).replace("{1}", this.designacion.local);
        }
      })
    }

    if (this.participantesVisitante.TieneParticipantes()) {
      this.participantesVisitante.lista.forEach((participante) => {
        if (!participante.participa) {
          let nombreJugador: string = this.licenciasVisitante.NombreCompletoPorParticipante(participante);

          texto += plantilla.replace("{0}", nombreJugador).replace("{1}", this.designacion.visitante);
        }
      })
    }

    if (this.designacion.OtrosDatos.incidenciasNoModificables == null) {
      this.designacion.OtrosDatos.incidentes = texto;
    } else {
      this.designacion.OtrosDatos.incidentes += texto;
    }

    this.designacion.OtrosDatos.Guardar().then((resultado: boolean) => {
      this.participacionCorrecta = true;
    });
  }

  /**
   * Se detecta la actualización del resultado parcial del partido
   *
   * @param {boolean} actualizado Indica si se ha actualizado el resultado
   * @memberof FinalizarPage
   */
  public ResultadoActualizado(actualizado: boolean): void {
    console.log("Actualizado resultado parcial");

    this.Persistentes.GetConfiguracion().then((resultado: iConfiguracion) => {
      this.ComprobarCondiciones(resultado);
    });
  }

  /**
   * Realiza la sincronización de la información de la designación
   */
  public Sincronizar(): void {
    let action: ActionSheet = this.ActionSheetController.create({
      title: "Finalizar designación",
      subTitle:
        "¿Desea finalizar la designación actual? Una vez finalizada, si se realiza el proceso correctamente, se eliminará de la lista de designaciones pendientes.",
      buttons: [
        {
          text: "CONFIRMAR",
          handler: () => {
            this.MostrarOcultarCarga(false, "finalizando designación");
            this.Persistentes.GetConfiguracion()
              .then((resultado: iConfiguracion) => {
                // Versión de la APP desde la que se ha realizado la designación
                this.designacion.OtrosDatos.versionCFutbolActas =
                  resultado.version;

                this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
                this.designacion.OtrosDatos.urlNombre =
                  this.designacion.urlNombre;

                return this.designacion.OtrosDatos.Guardar();
              })
              .then((resultado: boolean) => {
                // Finalización del acta
                return this.designacion.Finalizar();
              })
              .then((resultado: boolean) => {
                this.MostrarOcultarCarga(true);
                this.Mensaje(
                  "Se ha realizado correctamente el proceso de FINALIZACIÓN de la designación.",
                  10000
                );
                this.NavCtrl.setRoot(HomePage);

                // Eliminación del guardado de goles, para que la cabecera no los muestre.
                this.Persistentes.SetGolesLocal(undefined);
                this.Persistentes.SetGolesVisitante(undefined);

                // Eliminación del valor de la firma introducida (si lo hubiere)
                this.firma = "";
              })
              .catch((error) =>
                this.Error(error, "Finalizando la designación")
              );
          },
        },
        {
          text: "CANCELAR",
          role: "cancel",
        },
      ],
    });
    action.present();
  }

  /**
   * Comprueba si la firma indicada por el árbitro es correcta. En el caso de que lo sea, sigue con el proceso de la sincronización (Sincronizar())
   * @param form Datos del formulario asociado
   */
  public SincronizarConFirma(form: NgForm): void {
    if (form.valid) {
      this.MostrarOcultarCarga(false, "Comprobando firma de operaciones");
      // Se comprueba si la firma es correcta
      this.CFutbolActas.comprobarFirmaOperaciones(
        this.Persistentes.GetArbitro().idArbitro,
        this.firma
      )
        .then((resultado: boolean) => {
          this.MostrarOcultarCarga(true);

          if (resultado) {
            this.Sincronizar();
          } else {
            this.Mensaje("La firma indicada no es correcta", 4000);
          }
        })
        .catch((error) =>
          this.Error(error, "La firma indicada no es correcta.")
        );
    }
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/finalizar/finalizar.ts